import { useContext } from 'react';
import restClient from 'Shared/hooks/restClient'
import flow from './flow'

const actionSlices = {
  flow,
}

export default () => {
  const dis = useDis()
  const store = useStore()

  return useMemo(
    () => _.mapValues(actionSlices, (fn) => {
      return fn(dis, store, restClient)
    }),
    []
  )
}
